import * as types from "../actions/ActionTypes";

const defaultState = {
  isRequestingFollowers: false,
  followers: [],
  isRequestingFolloweds: false,
  followeds: [],
  isProcessingFollow: false,
  isProcessingUnfollow: false,
  errorUnfollowing: false,
  errorFollowing: false,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.FOLLOW_PENDING:
      return Object.assign({}, state, {
        isProcessingFollow: true,
      });
    case types.FOLLOW_FULFILLED:
      return Object.assign({}, state, {
        isProcessingFollow: false,
      });
    case types.FOLLOW_REJECTED:
      return Object.assign({}, state, {
        isProcessingFollow: false,
        errorFollowing: true,
      });
    case types.UNFOLLOW_PENDING:
      return Object.assign({}, state, {
        isProcessingUnfollow: true,
      });
    case types.UNFOLLOW_FULFILLED:
      return Object.assign({}, state, {
        isProcessingUnfollow: false,
      });
    case types.UNFOLLOW_REJECTED:
      return Object.assign({}, state, {
        isProcessingUnfollow: false,
        errorUnfollowing: true,
      });
    case types.FOLLOWERS_PENDING:
      return Object.assign({}, state, {
        isRequestingFollowers: true,
        followers: [],
      });
    case types.FOLLOWERS_FULFILLED:
      return Object.assign({}, state, {
        isRequestingFollowers: false,
        followers: action.payload,
      });
    case types.FOLLOWERS_REJECTED:
      return Object.assign({}, state, {
        isRequestingFollowers: false,
        followers: [],
      });
    case types.FOLLOWEDS_PENDING:
      return Object.assign({}, state, {
        isRequestingFolloweds: true,
        followeds: [],
      });
    case types.FOLLOWEDS_FULFILLED:
      return Object.assign({}, state, {
        isRequestingFolloweds: false,
        followeds: action.payload,
      });
    case types.FOLLOWEDS_REJECTED:
      return Object.assign({}, state, {
        isRequestingFolloweds: false,
        followeds: [],
      });
    case types.CLEAR_UNFOLLOW_ERROR:
      return Object.assign({}, state, {
        errorUnfollowing: false,
      });
    case types.CLEAR_FOLLOW_ERROR:
      return Object.assign({}, state, {
        errorFollowing: false,
      });

    case "LOGOUT":
      return defaultState;
    default:
      return state;
  }
}
